export default __webpack_public_path__ + "static/HomepageWomanOnBalcony-ef1e2bcc5b48c4e5d99950c185f4ec99.jpg";